/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  debug: true,
  use_mock: false,
  api_url: 'https://__DOMAIN__/frontend/',
  static_api: 'https://__DOMAIN__',
  jwt_refresh_endpoint: '/api/token/refresh/',
  jwt_create_endpoint: '/api/token/',
  jwt_delete_endpoint: '/api/token/',
  request_retry_number: 1,
};

if (environment.debug) {
  environment.api_url = 'http://aptbait.mysza.software/frontend/';
  environment.static_api = 'http://aptbait.mysza.software';
}
